import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import CommonDrawer from "../common/CommonDrawer";
import "./CategoryAdmin.css";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { toast } from "react-toastify";


function BrandAdmin() {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  const [category, setCategory] = useState(null);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  /* ---------- LOAD DATA ---------- */
  const loadCategories = async () => {
    const res = await axiosInstance.get("categories/");
    setCategories(res.data);
  };

  const loadBrands = async (catId) => {
    if (!catId) {
      setBrands([]);
      return;
    }
    const res = await axiosInstance.get(`brands/?category=${catId}`);
    setBrands(res.data);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    loadBrands(category);
  }, [category]);

  /* ---------- FORM ---------- */
  const resetForm = () => {
    setName("");
    setEditId(null);
    setOpen(false);
  };

  const saveBrand = async () => {
    if (!name || !category) {
      return toast.error("Category and Brand name required");
    }

    if (editId) {
      await axiosInstance.put(`brands/?id=${editId}`, {
        name,
        category,
      });
    } else {
      await axiosInstance.post("brands/", {
        name,
        category,
      });
    }

    resetForm();
    loadBrands(category);
  };

  const editBrand = (b) => {
    setEditId(b.id);
    setName(b.name);
    setCategory(b.category.id);
    setOpen(true);
  };

  const deleteBrand = async (id) => {
    if (window.confirm("Delete brand?")) {
      await axiosInstance.delete(`brands/?id=${id}`);
      loadBrands(category);
    }
  };

  return (
    <div className="category-admin">
      <div className="header">
        <h2>Brands</h2>

        <button
          className="primary-btn"
          onClick={() => {
            resetForm();
            setOpen(true);
          }}
        >
          + Add Brand
        </button>
      </div>

      <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
        <InputLabel>Category</InputLabel>
        <Select
          value={category}
          label="Category"
          onChange={(e) => setCategory(e.target.value)}
        >
          <MenuItem value="">
            <em>Select Category</em>
          </MenuItem>

          {categories.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <div className="table">
        <div className="table-head">
          <span>Brand Name</span>
          <span>Actions</span>
        </div>

        {brands.map((b) => (
          <div className="table-row" key={b.id}>
            <span className="name">{b.name}</span>
            <div className="actions">
              <button className="edit" onClick={() => editBrand(b)}>
                Edit
              </button>
              <button
                className="danger"
                onClick={() => deleteBrand(b.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}

        {!brands.length && category && (
          <div className="table-row">
            <span>No brands found</span>
          </div>
        )}
      </div>

      {/* DRAWER */}
      <CommonDrawer
        open={open}
        title={editId ? "Edit Brand" : "Add Brand"}
        onClose={resetForm}
      >
<FormControl fullWidth size="small" sx={{ mb: 2,mt:2 }}>
  <InputLabel id="category-drawer-label">Category</InputLabel>

  <Select
    labelId="category-drawer-label"
    value={category ?? ""}
    label="Category"
    onChange={(e) =>
      setCategory(e.target.value === "" ? null : Number(e.target.value))
    }
    MenuProps={{
      disablePortal: true
    }}
  >
    <MenuItem value="">
      <em>Select Category</em>
    </MenuItem>

    {categories.map((c) => (
      <MenuItem key={c.id} value={c.id}>
        {c.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

        <input
          className="input"
          placeholder="Brand name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <button className="primary-btn full" onClick={saveBrand}>
          {editId ? "Update" : "Save"}
        </button>
      </CommonDrawer>
    </div>
  );
}

export default BrandAdmin;
